/**
 * configuration redux constants
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// redux action IDs
export const UPDATE_CONFIGURATION           = 'UPDATE_CONFIGURATION';
export const LOAD_USER_SETTINGS             = 'LOAD_USER_SETTINGS';
export const CHANGE_USER_SETTING            = 'CHANGE_USER_SETTING';
